import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);

//实例store对象
const store = new Vuex.Store({
    state: {
        user: {},
        i18n: 'zh_TW',
        config: {},
        lang: {},
    },
    mutations: {
        /*......*/
    }
})

//导出store对象
export default store


// WEBPACK FOOTER //
// ./src/store/index.js